import { Slider } from "@/components/ui/slider";
import { useFieldContext } from "../../../../../question/components/organisms/FieldRenderer";
import { useEffect, useState } from "react";



export function SliderRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const { field_min, field_max, field_step, field_min_label, field_max_label, field_label } = question;
    const [value, setValue] = useState<number[]>([Math.ceil((field_max ?? 0) / 2)]);

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(()=>{
        const prepValue = value.length > 0 ? value[0].toString() : undefined;
        setFormValue && setFormValue(prepValue);
    },[value, setFormValue])

    return (
        <div className="flex flex-col w-full gap-2">
            <div className="grid grid-cols-3 gap-4">
                <p className="[font-size:12px] hyphens-auto w-full break-all">{field_min_label}</p>
                <p className="[font-size:12px] text-center">{field_label ?? <>&nbsp;</>}</p>
                <p className="[font-size:12px] text-end">{field_max_label}</p>
            </div>
            <div className="flex items-center">
                {!disabled ? (
                    <Slider min={field_min ?? undefined} max={field_max ?? undefined} step={field_step ?? 1} value={value} onValueChange={(e) => {
                        setValue(e);
                    }} />
                ) : (
                    <Slider min={field_min ?? undefined} max={field_max ?? undefined} step={field_step ?? 1} value={[Number(response?.field_value) ?? 0]} disabled />
                )}
            </div>
            <div className="grid grid-cols-3 gap-2">
                <div className="flex flex-col items-start justify-center text-sm">
                    <div className="text-center">
                        <p className="[font-size:12px]">Min:</p>
                        <p>{field_min ?? 0}</p>
                    </div>
                </div>
                <div className="flex flex-col items-center justify-center text-sm">
                    <div className="text-center">
                        <p className="[font-size:12px]">Value:</p>
                        <div className="mx-4 font-medium">{!disabled ? value : Number(response?.field_value || 0)}</div>
                    </div>
                </div>
                <div className="flex flex-col items-end justify-center text-sm">
                    <div className="text-center">
                        <p className="[font-size:12px]">Max:</p>
                        <p>{field_max}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}